import React from "react";
import { useI18n } from "../context/I18nContext.jsx";

const CONTENT = {
  nl: {
    title: "Algemene Voorwaarden",
    updated: "Laatst bijgewerkt: augustus 2026",
    sections: [
      {
        heading: "1. Definities",
        body: `In deze algemene voorwaarden wordt verstaan onder:

• ZyncFit — de virtuele pas-app en SaaS-dienst, aangeboden door [NOG IN TE VULLEN: juridische bedrijfsnaam], gevestigd te [NOG IN TE VULLEN: vestigingsplaats], ingeschreven bij de Kamer van Koophandel onder nummer [NOG IN TE VULLEN].
• Merchant — de webwinkel die ZyncFit installeert en gebruikt via het Shopify-platform.
• Eindklant — de consument die gebruikmaakt van de virtuele paskamer via de webwinkel van de Merchant.
• Dienst — het geheel van functionaliteiten dat ZyncFit biedt, waaronder de virtuele try-on, het AI-maatadvies, de e-mailverzending van resultaten en het klantdashboard.
• Sessie — een enkele virtuele try-on interactie waarbij een Eindklant een foto maakt en een pasresultaat ontvangt.`,
      },
      {
        heading: "2. Toepasselijkheid",
        body: `Deze algemene voorwaarden zijn van toepassing op:
• Ieder gebruik van de ZyncFit-app en -dienst door Merchants.
• Ieder gebruik van de virtuele paskamer door Eindklanten.

Door het installeren van ZyncFit vanuit de Shopify App Store of door het gebruik van de dienst gaat u akkoord met deze voorwaarden. Eventuele afwijkende voorwaarden van de Merchant of Eindklant worden uitdrukkelijk van de hand gewezen, tenzij schriftelijk anders overeengekomen.`,
      },
      {
        heading: "3. Beschrijving van de Dienst",
        body: `ZyncFit biedt de volgende functionaliteiten:

• Virtuele try-on — Eindklanten kunnen via een camera-widget in de webwinkel een selfie maken. Deze foto wordt samen met een kledingfoto door AI (Google Gemini) verwerkt tot een realistisch virtueel pasbeeld.
• Maatadvies — Op basis van door de Eindklant ingevoerde gegevens (lengte, gewicht, optioneel leeftijd) berekent ZyncFit een persoonlijke maataanbeveling op basis van de maattabellen van de Merchant.
• Landingspagina — Het resultaat wordt gepresenteerd op een persoonlijke landingspagina die per e-mail naar de Eindklant wordt verstuurd.
• Klantaccount — Eindklanten kunnen optioneel een account aanmaken om eerdere sessies terug te zien.
• Merchant-dashboard — Merchants hebben toegang tot een beheeromgeving voor productinstellingen, landingspagina-aanpassingen, branding, sessie-overzicht, klantbeheer en conversie-analytics.
• Maattabellen en maat-import — Merchants kunnen maattabellen uploaden of importeren voor nauwkeurigere maatadviezen.`,
      },
      {
        heading: "4. Gebruik van de Dienst",
        body: `4.1 De Merchant is verantwoordelijk voor het correct configureren van de app, waaronder het uploaden van kledingfoto's en maattabellen.

4.2 De Eindklant is verantwoordelijk voor het invoeren van correcte gegevens (lengte, gewicht, leeftijd). ZyncFit is niet aansprakelijk voor onjuist maatadvies als gevolg van foutieve invoer.

4.3 Het is niet toegestaan om de Dienst te gebruiken voor:
• Het uploaden van ongepaste, illegale of aanstootgevende beelden.
• Het geautomatiseerd (bot-matig) aanmaken van sessies.
• Ieder ander gebruik dat in strijd is met de wet, de openbare orde of de goede zeden.

4.4 ZyncFit behoudt zich het recht voor om bij misbruik de toegang tot de Dienst te beperken of te beëindigen.`,
      },
      {
        heading: "5. AI-disclaimer",
        body: `5.1 Het door ZyncFit gegenereerde virtuele pasbeeld en het maatadvies zijn indicatief en dienen als hulpmiddel bij het online winkelen. Het betreft een AI-schatting op basis van foto's en door de gebruiker ingevoerde gegevens.

5.2 ZyncFit garandeert niet dat:
• Het virtuele pasbeeld een exacte weergave is van hoe het kledingstuk in werkelijkheid zal staan.
• Het maatadvies in alle gevallen de juiste maat oplevert.
• De kleuren, pasvorm of verhoudingen exact overeenkomen met het fysieke kledingstuk.

5.3 De Merchant blijft verantwoordelijk voor de juistheid van de eigen maattabellen en productinformatie.

5.4 ZyncFit raadt Eindklanten aan om bij twijfel altijd het retourbeleid van de betreffende webwinkel te raadplegen.`,
      },
      {
        heading: "6. Prijzen en betaling",
        body: `[NOG IN TE VULLEN: Prijsmodel — gratis / abonnement / per sessie / freemium]
[NOG IN TE VULLEN: Factureringswijze en betaaltermijnen]
[NOG IN TE VULLEN: Beleid bij niet-betaling]

Alle genoemde prijzen zijn exclusief BTW, tenzij anders vermeld.`,
      },
      {
        heading: "7. Looptijd en opzegging",
        body: `[NOG IN TE VULLEN: Looptijd van het abonnement]
[NOG IN TE VULLEN: Opzegtermijn]
[NOG IN TE VULLEN: Automatische verlenging]

7.1 De Merchant kan de app op elk moment de-installeren via de Shopify App Store. Bij de-installatie wordt de toegangstoken direct verwijderd.

7.2 Alle gegevens van de Merchant worden 48 uur na de-installatie definitief gewist, conform de Shopify GDPR-vereisten (shop/redact webhook).`,
      },
      {
        heading: "8. Intellectueel eigendom",
        body: `8.1 Alle intellectuele eigendomsrechten op de ZyncFit-software, het platform, de algoritmen en de documentatie berusten bij ZyncFit (Zyncport).

8.2 De Merchant behoudt alle rechten op eigen content, waaronder productfoto's, maattabellen en branding-elementen die in de app worden geüpload.

8.3 De Eindklant behoudt de rechten op de door hemzelf gemaakte foto (selfie).

[NOG IN TE VULLEN: Wie is eigenaar van AI-gegenereerde beelden? (juridisch grijs gebied)]`,
      },
      {
        heading: "9. Aansprakelijkheid",
        body: `9.1 ZyncFit spant zich in om de Dienst naar beste vermogen te leveren, maar geeft geen garantie op ononderbroken beschikbaarheid.

9.2 ZyncFit is niet aansprakelijk voor:
• Schade als gevolg van onjuist maatadvies of een onnauwkeurig virtueel pasbeeld.
• Indirecte schade, gevolgschade, gederfde winst of gemiste besparingen.
• Schade veroorzaakt door storingen bij derde partijen (Google Gemini AI, Shopify, Vercel, e-mailprovider).
• Schade als gevolg van onjuiste of onvolledige gegevens ingevoerd door de Merchant of Eindklant.

9.3 Indien ZyncFit ondanks het voorgaande aansprakelijk wordt gehouden, is de totale aansprakelijkheid beperkt tot [NOG IN TE VULLEN: maximaal bedrag, bijv. het bedrag dat de Merchant in de voorafgaande 12 maanden aan ZyncFit heeft betaald, met een maximum van € X].

9.4 De beperkingen in dit artikel gelden niet voor schade veroorzaakt door opzet of grove schuld van ZyncFit.`,
      },
      {
        heading: "10. Privacy en gegevensbescherming",
        body: `10.1 ZyncFit verwerkt persoonsgegevens in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG) en het toepasselijke privacybeleid, beschikbaar op [URL privacybeleid].

10.2 De Merchant is verwerkingsverantwoordelijke voor de persoonsgegevens van Eindklanten. ZyncFit treedt op als verwerker.

10.3 Een verwerkersovereenkomst (DPA) kan worden aangevraagd via privacy@zyncport.com.

10.4 Meer informatie over gegevensverwerking is te vinden in ons privacybeleid.`,
      },
      {
        heading: "11. Beschikbaarheid en onderhoud",
        body: `11.1 ZyncFit streeft naar een hoge beschikbaarheid van de Dienst maar geeft hierop geen garantie.

[NOG IN TE VULLEN: SLA / uptime-garantie indien van toepassing]

11.2 ZyncFit is gerechtigd de Dienst tijdelijk buiten gebruik te stellen voor onderhoud, updates of verbeteringen. ZyncFit zal zich inspannen om dergelijke onderbrekingen zo veel mogelijk te beperken en, waar redelijkerwijs mogelijk, vooraf aan te kondigen.`,
      },
      {
        heading: "12. Overmacht",
        body: `12.1 ZyncFit is niet aansprakelijk voor het niet of niet-tijdig nakomen van verplichtingen als gevolg van overmacht.

12.2 Onder overmacht wordt onder meer verstaan: storingen bij derde dienstverleners (Google, Shopify, Vercel, e-mailprovider), stroomstoringen, internetuitval, DDoS-aanvallen, overheidsmaatregelen, epidemieën en andere omstandigheden buiten de macht van ZyncFit.

12.3 Bij overmacht van meer dan 60 dagen zijn beide partijen gerechtigd de overeenkomst te ontbinden zonder schadevergoeding.`,
      },
      {
        heading: "13. Wijzigingen",
        body: `13.1 ZyncFit behoudt zich het recht voor deze algemene voorwaarden te wijzigen.

13.2 Wijzigingen worden minimaal 30 dagen voor inwerkingtreding kenbaar gemaakt via e-mail aan de Merchant of via het merchant-dashboard.

13.3 Indien de Merchant niet akkoord gaat met de gewijzigde voorwaarden, kan de Merchant de overeenkomst opzeggen vóór de datum van inwerkingtreding.`,
      },
      {
        heading: "14. Toepasselijk recht en geschillen",
        body: `14.1 Op deze algemene voorwaarden en alle overeenkomsten tussen ZyncFit en de Merchant is Nederlands recht van toepassing.

14.2 Geschillen worden bij voorkeur in onderling overleg opgelost. Indien dit niet lukt, worden geschillen voorgelegd aan de bevoegde rechter in [NOG IN TE VULLEN: plaats van bevoegde rechtbank].`,
      },
      {
        heading: "15. Contact",
        body: `[NOG IN TE VULLEN: Juridische bedrijfsnaam]
[NOG IN TE VULLEN: Vestigingsadres]
KvK-nummer: [NOG IN TE VULLEN]
BTW-nummer: [NOG IN TE VULLEN]
E-mail: privacy@zyncport.com
[NOG IN TE VULLEN: Algemeen e-mailadres / telefoonnummer]`,
      },
    ],
  },
  en: {
    title: "Terms and Conditions",
    updated: "Last updated: August 2026",
    sections: [
      {
        heading: "1. Definitions",
        body: `In these terms and conditions, the following definitions apply:

• ZyncFit — the virtual try-on app and SaaS service, provided by [TO BE COMPLETED: legal entity name], registered at [TO BE COMPLETED: address], Chamber of Commerce number [TO BE COMPLETED].
• Merchant — the online store that installs and uses ZyncFit via the Shopify platform.
• End Customer — the consumer who uses the virtual fitting room via the Merchant's online store.
• Service — the full set of functionalities offered by ZyncFit, including virtual try-on, AI size advice, email delivery of results, and the customer dashboard.
• Session — a single virtual try-on interaction where an End Customer takes a photo and receives a fitting result.`,
      },
      {
        heading: "2. Applicability",
        body: `These terms and conditions apply to:
• All use of the ZyncFit app and service by Merchants.
• All use of the virtual fitting room by End Customers.

By installing ZyncFit from the Shopify App Store or by using the service, you agree to these terms. Any deviating terms of the Merchant or End Customer are expressly rejected unless otherwise agreed in writing.`,
      },
      {
        heading: "3. Description of the Service",
        body: `ZyncFit offers the following functionalities:

• Virtual try-on — End Customers can take a selfie via a camera widget in the online store. This photo is processed together with a garment photo by AI (Google Gemini) into a realistic virtual try-on image.
• Size advice — Based on data entered by the End Customer (height, weight, optionally age), ZyncFit calculates a personalised size recommendation based on the Merchant's size charts.
• Landing page — The result is presented on a personal landing page sent to the End Customer by email.
• Customer account — End Customers can optionally create an account to review previous sessions.
• Merchant dashboard — Merchants have access to a management interface for product settings, landing page customisation, branding, session overview, customer management, and conversion analytics.
• Size charts and import — Merchants can upload or import size charts for more accurate size advice.`,
      },
      {
        heading: "4. Use of the Service",
        body: `4.1 The Merchant is responsible for correctly configuring the app, including uploading garment photos and size charts.

4.2 The End Customer is responsible for entering correct data (height, weight, age). ZyncFit is not liable for incorrect size advice resulting from incorrect input.

4.3 It is not permitted to use the Service for:
• Uploading inappropriate, illegal, or offensive images.
• Automated (bot) creation of sessions.
• Any other use that violates the law, public order, or good morals.

4.4 ZyncFit reserves the right to restrict or terminate access to the Service in case of misuse.`,
      },
      {
        heading: "5. AI disclaimer",
        body: `5.1 The virtual try-on image and size advice generated by ZyncFit are indicative and serve as a tool for online shopping. They are AI estimates based on photos and user-entered data.

5.2 ZyncFit does not guarantee that:
• The virtual try-on image exactly represents how the garment will look in reality.
• The size advice will result in the correct size in all cases.
• Colours, fit, or proportions exactly match the physical garment.

5.3 The Merchant remains responsible for the accuracy of their own size charts and product information.

5.4 ZyncFit advises End Customers to always consult the return policy of the relevant online store when in doubt.`,
      },
      {
        heading: "6. Pricing and payment",
        body: `[TO BE COMPLETED: Pricing model — free / subscription / per session / freemium]
[TO BE COMPLETED: Billing method and payment terms]
[TO BE COMPLETED: Non-payment policy]

All stated prices are exclusive of VAT unless otherwise indicated.`,
      },
      {
        heading: "7. Term and termination",
        body: `[TO BE COMPLETED: Subscription term]
[TO BE COMPLETED: Notice period]
[TO BE COMPLETED: Automatic renewal]

7.1 The Merchant may uninstall the app at any time via the Shopify App Store. Upon uninstallation, the access token is immediately revoked.

7.2 All Merchant data is permanently deleted 48 hours after uninstallation, in accordance with Shopify GDPR requirements (shop/redact webhook).`,
      },
      {
        heading: "8. Intellectual property",
        body: `8.1 All intellectual property rights to the ZyncFit software, platform, algorithms, and documentation belong to ZyncFit (Zyncport).

8.2 The Merchant retains all rights to their own content, including product photos, size charts, and branding elements uploaded to the app.

8.3 The End Customer retains the rights to the photo (selfie) taken by them.

[TO BE COMPLETED: Who owns AI-generated images? (legally grey area)]`,
      },
      {
        heading: "9. Liability",
        body: `9.1 ZyncFit endeavours to deliver the Service to the best of its ability but does not guarantee uninterrupted availability.

9.2 ZyncFit is not liable for:
• Damage resulting from incorrect size advice or an inaccurate virtual try-on image.
• Indirect damage, consequential damage, lost profits, or missed savings.
• Damage caused by disruptions at third parties (Google Gemini AI, Shopify, Vercel, email provider).
• Damage resulting from incorrect or incomplete data entered by the Merchant or End Customer.

9.3 If ZyncFit is held liable despite the foregoing, total liability is limited to [TO BE COMPLETED: maximum amount, e.g. the amount paid by the Merchant in the preceding 12 months, up to a maximum of € X].

9.4 The limitations in this article do not apply to damage caused by intent or gross negligence of ZyncFit.`,
      },
      {
        heading: "10. Privacy and data protection",
        body: `10.1 ZyncFit processes personal data in accordance with the General Data Protection Regulation (GDPR) and the applicable privacy policy, available at [privacy policy URL].

10.2 The Merchant is the data controller for End Customer personal data. ZyncFit acts as a data processor.

10.3 A Data Processing Agreement (DPA) can be requested via privacy@zyncport.com.

10.4 More information about data processing can be found in our privacy policy.`,
      },
      {
        heading: "11. Availability and maintenance",
        body: `11.1 ZyncFit strives for high availability of the Service but provides no guarantee.

[TO BE COMPLETED: SLA / uptime guarantee if applicable]

11.2 ZyncFit is entitled to temporarily take the Service offline for maintenance, updates, or improvements. ZyncFit will endeavour to limit such interruptions and, where reasonably possible, announce them in advance.`,
      },
      {
        heading: "12. Force majeure",
        body: `12.1 ZyncFit is not liable for failure or delay in performing obligations due to force majeure.

12.2 Force majeure includes, but is not limited to: disruptions at third-party providers (Google, Shopify, Vercel, email provider), power outages, internet failures, DDoS attacks, government measures, epidemics, and other circumstances beyond ZyncFit's control.

12.3 If force majeure lasts more than 60 days, both parties are entitled to terminate the agreement without compensation.`,
      },
      {
        heading: "13. Changes",
        body: `13.1 ZyncFit reserves the right to modify these terms and conditions.

13.2 Changes will be communicated at least 30 days before taking effect via email to the Merchant or via the merchant dashboard.

13.3 If the Merchant does not agree with the amended terms, the Merchant may terminate the agreement before the effective date.`,
      },
      {
        heading: "14. Governing law and disputes",
        body: `14.1 These terms and conditions and all agreements between ZyncFit and the Merchant are governed by Dutch law.

14.2 Disputes will preferably be resolved amicably. If this fails, disputes will be submitted to the competent court in [TO BE COMPLETED: city of competent court].`,
      },
      {
        heading: "15. Contact",
        body: `[TO BE COMPLETED: Legal entity name]
[TO BE COMPLETED: Address]
Chamber of Commerce: [TO BE COMPLETED]
VAT number: [TO BE COMPLETED]
Email: privacy@zyncport.com
[TO BE COMPLETED: General email / phone number]`,
      },
    ],
  },
  de: {
    title: "Allgemeine Geschäftsbedingungen",
    updated: "Zuletzt aktualisiert: August 2026",
    sections: [
      {
        heading: "1. Definitionen",
        body: `In diesen AGB gelten folgende Definitionen:

• ZyncFit — die virtuelle Anprobe-App und der SaaS-Dienst, angeboten von [NOCH AUSZUFÜLLEN: Unternehmensbezeichnung], mit Sitz in [NOCH AUSZUFÜLLEN: Adresse], Handelsregisternummer [NOCH AUSZUFÜLLEN].
• Händler — der Onlineshop, der ZyncFit über die Shopify-Plattform installiert und nutzt.
• Endkunde — der Verbraucher, der die virtuelle Umkleidekabine über den Onlineshop des Händlers nutzt.
• Dienst — die Gesamtheit der von ZyncFit angebotenen Funktionalitäten, einschließlich virtueller Anprobe, KI-Größenempfehlung, E-Mail-Versand der Ergebnisse und Kunden-Dashboard.
• Sitzung — eine einzelne virtuelle Anprobe-Interaktion, bei der ein Endkunde ein Foto macht und ein Anprobeergebnis erhält.`,
      },
      {
        heading: "2. Geltungsbereich",
        body: `Diese AGB gelten für:
• Jede Nutzung der ZyncFit-App und des Dienstes durch Händler.
• Jede Nutzung der virtuellen Umkleidekabine durch Endkunden.

Mit der Installation von ZyncFit aus dem Shopify App Store oder durch die Nutzung des Dienstes stimmen Sie diesen Bedingungen zu. Abweichende Bedingungen des Händlers oder Endkunden werden ausdrücklich zurückgewiesen, sofern nicht schriftlich anders vereinbart.`,
      },
      {
        heading: "3. Beschreibung des Dienstes",
        body: `ZyncFit bietet folgende Funktionalitäten:

• Virtuelle Anprobe — Endkunden können über ein Kamera-Widget im Onlineshop ein Selfie aufnehmen. Dieses Foto wird zusammen mit einem Kleidungsfoto von KI (Google Gemini) zu einem realistischen virtuellen Anprobebild verarbeitet.
• Größenempfehlung — Auf Basis der vom Endkunden eingegebenen Daten (Größe, Gewicht, optional Alter) berechnet ZyncFit eine persönliche Größenempfehlung anhand der Größentabellen des Händlers.
• Landingpage — Das Ergebnis wird auf einer persönlichen Landingpage präsentiert, die dem Endkunden per E-Mail zugesendet wird.
• Kundenkonto — Endkunden können optional ein Konto erstellen, um frühere Sitzungen einzusehen.
• Händler-Dashboard — Händler haben Zugang zu einer Verwaltungsoberfläche für Produkteinstellungen, Landingpage-Anpassungen, Branding, Sitzungsübersicht, Kundenverwaltung und Conversion-Analytics.
• Größentabellen und Import — Händler können Größentabellen hochladen oder importieren für genauere Größenempfehlungen.`,
      },
      {
        heading: "4. Nutzung des Dienstes",
        body: `4.1 Der Händler ist verantwortlich für die korrekte Konfiguration der App, einschließlich des Hochladens von Kleidungsfotos und Größentabellen.

4.2 Der Endkunde ist verantwortlich für die Eingabe korrekter Daten (Größe, Gewicht, Alter). ZyncFit haftet nicht für fehlerhafte Größenempfehlungen aufgrund falscher Eingaben.

4.3 Es ist nicht gestattet, den Dienst zu nutzen für:
• Das Hochladen unangemessener, illegaler oder anstößiger Bilder.
• Automatisierte (Bot-)Erstellung von Sitzungen.
• Jede andere Nutzung, die gegen Gesetze, die öffentliche Ordnung oder die guten Sitten verstößt.

4.4 ZyncFit behält sich das Recht vor, den Zugang zum Dienst bei Missbrauch einzuschränken oder zu beenden.`,
      },
      {
        heading: "5. KI-Haftungsausschluss",
        body: `5.1 Das von ZyncFit generierte virtuelle Anprobebild und die Größenempfehlung sind Richtwerte und dienen als Hilfsmittel beim Online-Einkauf. Es handelt sich um KI-Schätzungen auf Basis von Fotos und nutzereingegebenen Daten.

5.2 ZyncFit garantiert nicht, dass:
• Das virtuelle Anprobebild genau darstellt, wie das Kleidungsstück in der Realität aussehen wird.
• Die Größenempfehlung in allen Fällen die richtige Größe ergibt.
• Farben, Passform oder Proportionen genau mit dem physischen Kleidungsstück übereinstimmen.

5.3 Der Händler bleibt verantwortlich für die Richtigkeit der eigenen Größentabellen und Produktinformationen.

5.4 ZyncFit empfiehlt Endkunden, im Zweifelsfall stets die Rückgaberichtlinie des jeweiligen Onlineshops zu konsultieren.`,
      },
      {
        heading: "6. Preise und Zahlung",
        body: `[NOCH AUSZUFÜLLEN: Preismodell — kostenlos / Abonnement / pro Sitzung / Freemium]
[NOCH AUSZUFÜLLEN: Abrechnungsweise und Zahlungsfristen]
[NOCH AUSZUFÜLLEN: Richtlinie bei Nichtzahlung]

Alle genannten Preise verstehen sich zzgl. MwSt., sofern nicht anders angegeben.`,
      },
      {
        heading: "7. Laufzeit und Kündigung",
        body: `[NOCH AUSZUFÜLLEN: Vertragslaufzeit]
[NOCH AUSZUFÜLLEN: Kündigungsfrist]
[NOCH AUSZUFÜLLEN: Automatische Verlängerung]

7.1 Der Händler kann die App jederzeit über den Shopify App Store deinstallieren. Bei Deinstallation wird das Zugriffstoken sofort widerrufen.

7.2 Alle Händlerdaten werden 48 Stunden nach der Deinstallation endgültig gelöscht, gemäß den Shopify-DSGVO-Anforderungen (shop/redact Webhook).`,
      },
      {
        heading: "8. Geistiges Eigentum",
        body: `8.1 Alle geistigen Eigentumsrechte an der ZyncFit-Software, der Plattform, den Algorithmen und der Dokumentation liegen bei ZyncFit (Zyncport).

8.2 Der Händler behält alle Rechte an eigenen Inhalten, einschließlich Produktfotos, Größentabellen und Branding-Elementen, die in die App hochgeladen werden.

8.3 Der Endkunde behält die Rechte an dem von ihm aufgenommenen Foto (Selfie).

[NOCH AUSZUFÜLLEN: Wem gehören KI-generierte Bilder? (rechtliche Grauzone)]`,
      },
      {
        heading: "9. Haftung",
        body: `9.1 ZyncFit bemüht sich, den Dienst bestmöglich zu erbringen, gibt jedoch keine Garantie für ununterbrochene Verfügbarkeit.

9.2 ZyncFit haftet nicht für:
• Schäden infolge fehlerhafter Größenempfehlung oder eines ungenauen virtuellen Anprobebildes.
• Indirekte Schäden, Folgeschäden, entgangenen Gewinn oder verpasste Einsparungen.
• Schäden durch Störungen bei Dritten (Google Gemini AI, Shopify, Vercel, E-Mail-Anbieter).
• Schäden infolge unrichtiger oder unvollständiger Daten des Händlers oder Endkunden.

9.3 Sollte ZyncFit trotz des Vorstehenden haftbar gemacht werden, ist die Gesamthaftung begrenzt auf [NOCH AUSZUFÜLLEN: Höchstbetrag, z. B. den vom Händler in den vorangegangenen 12 Monaten gezahlten Betrag, maximal € X].

9.4 Die Beschränkungen in diesem Artikel gelten nicht für Schäden durch Vorsatz oder grobe Fahrlässigkeit von ZyncFit.`,
      },
      {
        heading: "10. Datenschutz",
        body: `10.1 ZyncFit verarbeitet personenbezogene Daten gemäß der Datenschutz-Grundverordnung (DSGVO) und der geltenden Datenschutzerklärung, verfügbar unter [URL Datenschutzerklärung].

10.2 Der Händler ist Verantwortlicher für die personenbezogenen Daten der Endkunden. ZyncFit ist Auftragsverarbeiter.

10.3 Ein Auftragsverarbeitungsvertrag (AVV) kann über privacy@zyncport.com angefordert werden.

10.4 Weitere Informationen zur Datenverarbeitung finden Sie in unserer Datenschutzerklärung.`,
      },
      {
        heading: "11. Verfügbarkeit und Wartung",
        body: `11.1 ZyncFit strebt eine hohe Verfügbarkeit des Dienstes an, gibt jedoch keine Garantie.

[NOCH AUSZUFÜLLEN: SLA / Verfügbarkeitsgarantie, falls zutreffend]

11.2 ZyncFit ist berechtigt, den Dienst vorübergehend für Wartung, Updates oder Verbesserungen außer Betrieb zu nehmen. ZyncFit wird sich bemühen, solche Unterbrechungen so gering wie möglich zu halten und, soweit zumutbar, vorab anzukündigen.`,
      },
      {
        heading: "12. Höhere Gewalt",
        body: `12.1 ZyncFit haftet nicht für die Nichterfüllung oder verspätete Erfüllung von Verpflichtungen aufgrund höherer Gewalt.

12.2 Höhere Gewalt umfasst unter anderem: Störungen bei Drittanbietern (Google, Shopify, Vercel, E-Mail-Anbieter), Stromausfälle, Internetausfälle, DDoS-Angriffe, behördliche Maßnahmen, Epidemien und andere Umstände außerhalb der Kontrolle von ZyncFit.

12.3 Dauert die höhere Gewalt länger als 60 Tage, sind beide Parteien berechtigt, den Vertrag ohne Entschädigung zu kündigen.`,
      },
      {
        heading: "13. Änderungen",
        body: `13.1 ZyncFit behält sich das Recht vor, diese AGB zu ändern.

13.2 Änderungen werden mindestens 30 Tage vor Inkrafttreten per E-Mail an den Händler oder über das Händler-Dashboard mitgeteilt.

13.3 Stimmt der Händler den geänderten Bedingungen nicht zu, kann er den Vertrag vor dem Inkrafttreten kündigen.`,
      },
      {
        heading: "14. Anwendbares Recht und Streitigkeiten",
        body: `14.1 Diese AGB und alle Vereinbarungen zwischen ZyncFit und dem Händler unterliegen niederländischem Recht.

14.2 Streitigkeiten werden vorzugsweise gütlich beigelegt. Gelingt dies nicht, werden Streitigkeiten dem zuständigen Gericht in [NOCH AUSZUFÜLLEN: zuständiger Gerichtsort] vorgelegt.`,
      },
      {
        heading: "15. Kontakt",
        body: `[NOCH AUSZUFÜLLEN: Unternehmensbezeichnung]
[NOCH AUSZUFÜLLEN: Adresse]
Handelsregister: [NOCH AUSZUFÜLLEN]
USt-IdNr.: [NOCH AUSZUFÜLLEN]
E-Mail: privacy@zyncport.com
[NOCH AUSZUFÜLLEN: Allgemeine E-Mail / Telefonnummer]`,
      },
    ],
  },
};

export default function TermsPage() {
  const { lang } = useI18n();
  const c = CONTENT[lang] || CONTENT.nl;

  return (
    <div style={{ maxWidth: 760, margin: "0 auto", padding: "48px 24px 80px", fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", color: "#1a1a1a", lineHeight: 1.7 }}>
      <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 4 }}>{c.title}</h1>
      <p style={{ fontSize: 13, color: "#888", marginBottom: 36 }}>{c.updated}</p>
      {c.sections.map(({ heading, body }) => (
        <section key={heading} style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>{heading}</h2>
          <p style={{ fontSize: 15, color: "#333", whiteSpace: "pre-line", margin: 0 }}>{body}</p>
        </section>
      ))}
      <footer style={{ marginTop: 48, paddingTop: 20, borderTop: "1px solid #e5e5e5", textAlign: "center", fontSize: 12, color: "#aaa" }}>
        &copy; {new Date().getFullYear()} ZyncFit &mdash; Powered by Zyncport
      </footer>
    </div>
  );
}
